export default {
  setState: 'Ustaw stan urządzenia',
  stop: 'Zatrzymaj: {eventType}',
  start: 'Uruchom: {eventType}',
};
